import { render } from "./SwdShareDialog.vue?vue&type=template&id=04fc58ae"
import script from "./SwdShareDialog.vue?vue&type=script&lang=js"
export * from "./SwdShareDialog.vue?vue&type=script&lang=js"

import "./SwdShareDialog.vue?vue&type=style&index=0&id=04fc58ae&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__